(() => {
  const header = document.querySelector('.cova-header');
  if (!header || header.dataset.enhanced) return;
  header.dataset.enhanced = 'true';
  const panel = header.querySelector('.cova-navigation');
  const open = header.querySelector('.cova-menu-open');
  const close = header.querySelector('.cova-menu-close');
  const mobile = matchMedia('(max-width: 900px)');
  const menus = [...header.querySelectorAll('details')];
  const background = [
    open,
    header.querySelector('.cova-brand'),
    header.querySelector('.cova-utility'),
    document.querySelector('.skip-to-content-link'),
    document.querySelector('#MainContent'),
    document.querySelector('.cova-footer'),
  ].filter(Boolean);
  const addedInert = new Set();
  function isolateMenu() {
    background.forEach(element => {
      if (!element.hasAttribute('inert')) {
        element.setAttribute('inert', '');
        addedInert.add(element);
      }
    });
  }
  function restoreBackground() {
    addedInert.forEach(element => element.removeAttribute('inert'));
    addedInert.clear();
  }
  function closeMenu(restore = true) {
    header.classList.remove('menu-is-open');
    open.setAttribute('aria-expanded', 'false');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    panel.removeAttribute('aria-label');
    document.body.classList.remove('cova-menu-lock');
    restoreBackground();
    menus.forEach(menu => { menu.open = false; });
    if (restore) open.focus();
  }
  function refresh() {
    closeMenu(false);
    open.hidden = !mobile.matches;
    close.hidden = !mobile.matches;
    header.classList.toggle('cova-mobile-enhanced', mobile.matches);
  }
  open.addEventListener('click', () => {
    header.classList.add('menu-is-open');
    open.setAttribute('aria-expanded', 'true');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', panel.dataset.dialogLabel);
    document.body.classList.add('cova-menu-lock');
    isolateMenu();
    close.focus();
  });
  close.addEventListener('click', () => closeMenu());
  header.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (mobile.matches && header.classList.contains('menu-is-open')) closeMenu();
      else {
        const menu = event.target.closest('details');
        if (menu?.open) { menu.open = false; menu.querySelector('summary').focus(); }
      }
    }
    if (event.key !== 'Tab' || !header.classList.contains('menu-is-open')) return;
    const focusable = [...panel.querySelectorAll('a,button,summary,select')].filter(el => el.getClientRects().length && !el.hidden);
    const first = focusable[0], last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) menus.filter(other => other !== menu).forEach(other => { other.open = false; });
  }));
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) menus.forEach(menu => { menu.open = false; });
  });
  mobile.addEventListener('change', refresh);
  refresh();
})();
